module.exports = __webpack_public_path__ + "static/HardwareHero-61edeb65415912890829e0c387c45ef7.png";